export const ACTION_TYPES = {
    CLEAN_APPOINTMENT_LIST_ERROR: 'CLEAN_APPOINTMENT_LIST_ERROR',
    CLEAN_APPOINTMENT_LIST: 'CLEAN_APPOINTMENT_LIST',

    CLEAN_APPOINTMENT_LIST_FILTER: 'CLEAN_APPOINTMENT_LIST_FILTER',
    CHANGE_APPOINTMENT_LIST_FILTER: 'CHANGE_APPOINTMENT_LIST_FILTER',
    CHANGE_APPOINTMENT_LIST_FILTER_FIELD: 'CHANGE_APPOINTMENT_LIST_FILTER_FIELD',
    
    LOAD_APPOINTMENT_LIST_REQUEST: 'LOAD_APPOINTMENT_LIST_REQUEST',
    LOAD_APPOINTMENT_LIST_SUCCESS: 'LOAD_APPOINTMENT_LIST_SUCCESS',
    LOAD_APPOINTMENT_LIST_FAILURE: 'LOAD_APPOINTMENT_LIST_FAILURE'
};
